import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { t } from "i18next";
import { SendIcon } from "lucide-react";
import { useState } from "react";
import { DialogReferralSendLead } from "./dialog-referral-send-lead";

export const CardReferralSendLead = () => {
  const [isSendLeadDialogOpen, setIsSendLeadDialogOpen] = useState(false);

  return (
    <>
      <Card className="flex flex-col flex-1 justify-between">
        <CardHeader>
          <CardTitle>{t("referrals.sendLead.title")}</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col flex-1 justify-between">
          <div className="mb-4 text-sm text-muted-foreground">
            {t("referrals.sendLead.description")}
          </div>
          <Button
            type="button"
            className="mt-auto"
            onClick={() => setIsSendLeadDialogOpen(true)}
          >
            <SendIcon className="mr-2 w-4 h-4" />
            {t("referrals.sendLead.button")}
          </Button>
        </CardContent>
      </Card>

      <DialogReferralSendLead
        isOpen={isSendLeadDialogOpen}
        onClose={() => setIsSendLeadDialogOpen(false)}
      />
    </>
  );
};
